import {
	SET_TEMPLATE_FOLDERS,
	ADD_TEMPLATE_FOLDER,
	REMOVE_TEMPLATE_FOLDER,
	UPDATE_TEMPLATE_FOLDER,
} from '@/actions/types';

const initialState = [];

const sortByTitle = (folders) =>
	[...folders].sort((a, b) => {
		const titleA = (a.title || '').toString();
		const titleB = (b.title || '').toString();
		return titleA.localeCompare(titleB);
	});

export default function templateFoldersReducer(state = initialState, action) {
	switch (action.type) {
		case SET_TEMPLATE_FOLDERS:
			return sortByTitle(action.payload || []);
		case ADD_TEMPLATE_FOLDER:
			return sortByTitle([...state, action.payload]);
		case REMOVE_TEMPLATE_FOLDER:
			return state.filter((folder) => folder._id !== action.payload);
		case UPDATE_TEMPLATE_FOLDER:
			return sortByTitle(
				state.map((folder) =>
					folder._id === action.payload._id ? action.payload : folder
				)
			);
		default:
			return state;
	}
}
